module.exports = __webpack_public_path__ + "img/sc-1.59cd793a.png";